import { CustomMapThemeExe } from "./custom-map-theme-exe";
export class StreetThemeExe extends CustomMapThemeExe {}
